<template>
  <div class="order-container">
    <!-- ==================== 筛选区域 ==================== -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="商品名称">
          <el-input v-model="filterForm.comlist_v1" placeholder="搜索商品名称" clearable @keyup.enter="handleSearch" />
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker v-model="filterForm.start_date" type="date" placeholder="选择开始日期" value-format="yyyy-MM-dd" clearable />
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker v-model="filterForm.end_date" type="date" placeholder="选择结束日期" value-format="yyyy-MM-dd" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <!-- <el-button type="success" icon="el-icon-upload2" @click="handleImportExcel">导入入库单</el-button> -->
          <el-button type="warning" icon="el-icon-plus" @click="openCreateDialog">自营入库</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- ==================== 列表区域 ==================== -->
    <el-card class="table-card" shadow="never" >
      <el-table v-loading="loading" :data="orderList" border stripe @row-click="openDetail" style="width: 100%" >
        <el-table-column prop="batch" label="批次" min-width="140" show-overflow-tooltip />
        <el-table-column prop="is_self_operated" label="类型" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.is_self_operated" size="small" type="success">自营</el-tag>
            <el-tag v-else size="small" type="info">外部</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="creator" label="创建人" width="100" />
        <el-table-column prop="create_time" label="创建时间" width="170" />
        <el-table-column prop="comlist_m1" label="备注" min-width="120" show-overflow-tooltip />
        <el-table-column label="货品数" width="80">
          <template slot-scope="scope">
            {{ scope.row.goods_list ? scope.row.goods_list.length : 0 }}
          </template>
        </el-table-column>
        <el-table-column label="总数量" width="90">
          <template slot-scope="scope">
            {{ calculateTotalQuantity(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="总重量(斤)" width="110">
          <template slot-scope="scope">
            {{ calculateTotalWeightForList(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="总金额(元)" width="130">
          <template slot-scope="scope">
            <span class="money">¥{{ calculateTotalAmountForList(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.stop="openDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="Number(total)"
        background
      />
    </el-card>

    <!-- ==================== 入库单详情弹窗 ==================== -->
    <el-dialog title="入库单详情" :visible.sync="detailDialogVisible" width="75%" @close="closeDetail">
      <div v-if="currentDetail">
        <el-descriptions :column="2" border class="detail-desc">
          <el-descriptions-item label="批次">{{ currentDetail.batch || '--' }}</el-descriptions-item>
          <el-descriptions-item label="类型">
            <el-tag v-if="currentDetail.is_self_operated" size="small" type="success">自营</el-tag>
            <el-tag v-else size="small" type="info">外部</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="创建人">{{ currentDetail.creator || '--' }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ currentDetail.create_time || '--' }}</el-descriptions-item>
          <el-descriptions-item label="相关费用">
            <span class="money">￥{{ currentDetail.feeAmount || '0.00' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="备注">{{ currentDetail.comlist_m1 || '--' }}</el-descriptions-item>
        </el-descriptions>

        <div style="margin-top: 16px; font-weight: 600; font-size: 14px;">货品明细</div>
        <el-table :data="currentDetail.goods_list || []" border style="margin-top: 8px; width: 100%">
          <el-table-column prop="comlist_v1" label="货品" min-width="120" show-overflow-tooltip />
          <el-table-column prop="comlist_v2" label="规格" width="100" />
          <el-table-column prop="comlist_s1" label="数量" width="80" />
          <el-table-column prop="comlist_v6" label="重量(斤)" width="100" />
          <el-table-column label="采购价" width="110">
            <template slot-scope="scope">¥{{ formatPrice(scope.row.comlist_f1) }}</template>
          </el-table-column>
          <el-table-column label="小计(元)" width="120">
            <template slot-scope="scope">
              <span class="money">¥{{ calculateSubtotal(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="90">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="openEditPrice(scope.row)">修改价</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div style="margin-top: 16px; background: #f5f7fa; padding: 12px 16px; border-radius: 4px;">
          <el-row :gutter="20">
            <el-col :span="6">
              <span style="color: #666;">合计数量：</span>
              <strong>{{ calculateTotalQuantityForDetail(currentDetail.goods_list) }}</strong>
            </el-col>
            <el-col :span="6">
              <span style="color: #666;">合计重量：</span>
              <strong>{{ calculateTotalWeight(currentDetail.goods_list) }} 斤</strong>
            </el-col>
            <el-col :span="6">
              <span style="color: #666;">货品总额：</span>
              <strong class="money">¥{{ calculateTotalAmount(currentDetail.goods_list) }}</strong>
            </el-col>
            <el-col :span="6">
              <span style="color: #666;">应付总额：</span>
              <strong class="money" style="font-size: 16px;">¥{{ calculateFinalTotal(currentDetail) }}</strong>
            </el-col>
          </el-row>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="detailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- ==================== 创建入库单弹窗 ==================== -->
    <el-dialog title="自营入库" :visible.sync="createDialogVisible" width="70%" :close-on-click-modal="false" @close="resetCreateForm">
      <el-form :model="createForm" label-width="100px" size="small">
        <el-row :gutter="20">
          <!-- <el-col :span="12">
            <el-form-item label="销售点" required>
              <el-select v-model="createForm.salesPoint" placeholder="请选择销售点" style="width:100%">
                <el-option v-for="item in salesPointList" :key="item.id" :label="item.name" :value="item.name" />
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="20">
            <el-form-item label="到货日期" required>
              <el-date-picker v-model="createForm.arrivalDate" type="date" placeholder="选择到货日期" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="主批次号" required>
              <el-input v-model="createForm.batchNumber" placeholder="请输入批次号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注">
              <el-input v-model="createForm.remark" placeholder="请输入备注" />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 入库费用 -->
        <el-form-item label="入库费用">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-select v-model="feePaymentMethod" placeholder="支付方式" clearable>
                <el-option v-for="item in paymentMethodOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="feeExpenseCategory" placeholder="支出类别" clearable>
                <el-option v-for="item in expenseCategoryOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-input v-model="feeAmount" placeholder="金额" type="number" />
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="addRelatedFee">添加费用</el-button>
            </el-col>
          </el-row>
          <div v-if="createForm.relatedFeesText && createForm.relatedFeesText !== '点击添加'" style="margin-top:6px;color:#409EFF;font-size:13px;">
            {{ createForm.relatedFeesText }}
          </div>
        </el-form-item>

        <!-- 已选货品列表 -->
        <el-form-item label="已选货品">
          <el-table :data="selectedGoods" border style="width:100%">
            <el-table-column prop="name" label="货品" min-width="100" show-overflow-tooltip />
            <el-table-column prop="mx_comlist_v1" label="规格" width="80" />
            <el-table-column prop="quantity" label="数量" width="80" />
            <el-table-column prop="weight" label="重量(斤)" width="100" />
            <el-table-column prop="purchasePrice" label="采购价" width="100">
              <template slot-scope="scope">¥{{ formatPrice(scope.row.purchasePrice) }}</template>
            </el-table-column>
            <el-table-column label="小计" width="110">
              <template slot-scope="scope"><span class="money">¥{{ (parseFloat(scope.row.quantity||0) * parseFloat(scope.row.purchasePrice||0)).toFixed(2) }}</span></template>
            </el-table-column>
            <el-table-column prop="ghs_name" label="供货商" width="100" show-overflow-tooltip />
            <el-table-column label="操作" width="140">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="openEditGoods(scope.$index)">编辑</el-button>
                <el-button type="text" size="mini" style="color:#F56C6C;" @click="deleteGoods(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top:8px;">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="openSelectGoods">添加货品</el-button>
            <span style="margin-left:12px;color:#999;font-size:13px;">共 {{ selectedGoods.length }} 件</span>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="createDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitInStock" :disabled="!isConfirmEnabled" :loading="submitLoading">确认入库</el-button>
      </span>
    </el-dialog>

    <!-- ==================== 选择货品弹窗 ==================== -->
    <el-dialog title="选择货品" :visible.sync="selectGoodsDialogVisible" width="75%" :close-on-click-modal="false" @close="closeSelectGoods">
      <div style="margin-bottom:12px;">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-select v-model="currentGroupId" placeholder="选择分组" clearable @change="fetchGoodsData" style="width:100%">
              <el-option v-for="g in groupList" :key="g.id" :label="g.name" :value="g.id" />
            </el-select>
          </el-col>
          <el-col :span="10">
            <el-input v-model="goodsSearchKeyword" placeholder="搜索货品名称" clearable @keyup.enter="fetchGoodsData" />
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="fetchGoodsData">搜索</el-button>
            <el-button @click="goodsSearchKeyword='';fetchGoodsData()">重置</el-button>
          </el-col>
        </el-row>
      </div>

      <el-table v-loading="goodsLoading" :data="goodsList" border stripe style="width:100%">
        <el-table-column prop="goods_name" label="货品名称" min-width="140" show-overflow-tooltip />
        <el-table-column label="库存" width="100">
          <template slot-scope="scope">{{ getGoodsStock(scope.row) }}件</template>
        </el-table-column>
        <el-table-column label="规格" width="120">
          <template slot-scope="scope">
            <el-tag v-for="(spec, idx) in scope.row.specs" :key="idx" size="mini" style="margin:2px;">
              {{ spec.comlist_v1 }}
            </el-tag>
            <span v-if="!scope.row.specs || scope.row.specs.length===0" style="color:#999;">无规格</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="openGoodsDetail(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="handleGoodsPageChange"
        :current-page="goodsPage"
        :page-size="goodsPageSize"
        layout="total, prev, pager, next"
        :total="goodsTotal"
        background
        small
      />
      <span slot="footer">
        <el-button @click="selectGoodsDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- ==================== 货品详情/编辑弹窗（选择货品时填写数量/价格） ==================== -->
    <el-dialog title="货品详情" :visible.sync="goodsDetailDialogVisible" width="450px" :close-on-click-modal="false" @close="resetGoodsDetail">
      <el-form :model="goodsDetailForm" label-width="90px" size="small">
        <el-form-item label="货品名称">
          <span>{{ goodsDetailForm.name }}</span>
        </el-form-item>
        <el-form-item label="规格">
          <el-select v-model="goodsDetailForm.specId" placeholder="请选择规格" @change="onSpecChange">
            <el-option v-for="s in goodsDetailForm.specs" :key="s.id" :label="s.comlist_v1" :value="s.id" />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="供货商">
          <el-select v-model="goodsDetailForm.supplierId" placeholder="选择供货商" filterable>
            <el-option v-for="s in supplierList" :key="s.id" :label="s.name" :value="s.id" />
          </el-select>
        </el-form-item> -->
        <el-form-item label="数量(件)">
          <el-input-number v-model="goodsDetailForm.quantity" :min="0" :precision="0" controls-position="right" style="width:100%" />
        </el-form-item>
        <el-form-item label="重量(斤)">
          <el-input-number v-model="goodsDetailForm.weight" :min="0" :precision="2" controls-position="right" style="width:100%" />
        </el-form-item>
        <el-form-item label="采购价(元/件)">
          <el-input-number v-model="goodsDetailForm.purchasePrice" :min="0" :precision="2" controls-position="right" style="width:100%" />
        </el-form-item>
        <el-form-item label="小计">
          <span class="money">¥{{ (goodsDetailForm.quantity * goodsDetailForm.purchasePrice).toFixed(2) }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="goodsDetailDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmGoodsDetail">确认添加</el-button>
      </span>
    </el-dialog>

    <!-- ==================== 编辑采购价弹窗 ==================== -->
    <el-dialog title="修改采购价" :visible.sync="editPriceDialogVisible" width="400px" :close-on-click-modal="false">
      <el-form label-width="100px" size="small">
        <el-form-item label="货品">
          <span>{{ editPriceGoods ? editPriceGoods.comlist_v1 + '(' + editPriceGoods.comlist_v2 + ')' : '' }}</span>
        </el-form-item>
        <el-form-item label="当前采购价">
          <span class="money">¥{{ formatPrice(editPriceGoods ? editPriceGoods.comlist_f1 : 0) }}</span>
        </el-form-item>
        <el-form-item label="新采购价">
          <el-input-number v-model="editPriceValue" :min="0" :precision="2" controls-position="right" style="width:100%" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editPriceDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmEditPrice" :loading="editPriceLoading">确 认</el-button>
      </span>
    </el-dialog>

    <!-- ==================== 编辑已选货品弹窗（创建入库单中编辑） ==================== -->
    <el-dialog title="编辑货品" :visible.sync="editSelectedGoodsDialogVisible" width="450px" :close-on-click-modal="false">
      <el-form :model="editSelectedForm" label-width="90px" size="small">
        <el-form-item label="货品">
          <span>{{ editSelectedForm.name }}({{ editSelectedForm.mx_comlist_v1 }})</span>
        </el-form-item>
        <!-- <el-form-item label="供货商">
          <el-select v-model="editSelectedForm.ghs_id" placeholder="选择供货商" filterable>
            <el-option v-for="s in supplierList" :key="s.id" :label="s.name" :value="s.id" />
          </el-select>
        </el-form-item> -->
        <el-form-item label="数量(件)">
          <el-input-number v-model="editSelectedForm.quantity" :min="0" :precision="0" controls-position="right" style="width:100%" />
        </el-form-item>
        <el-form-item label="重量(斤)">
          <el-input-number v-model="editSelectedForm.weight" :min="0" :precision="2" controls-position="right" style="width:100%" />
        </el-form-item>
        <el-form-item label="采购价(元/件)">
          <el-input-number v-model="editSelectedForm.purchasePrice" :min="0" :precision="2" controls-position="right" style="width:100%" />
        </el-form-item>
        <el-form-item label="小计">
          <span class="money">¥{{ (editSelectedForm.quantity * editSelectedForm.purchasePrice).toFixed(2) }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editSelectedGoodsDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmEditSelectedGoods">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'StorageOrderManage',
  data () {
    const today = new Date()
    const start = new Date()
    start.setDate(start.getDate() - 30)
    return {
      // ========== 列表筛选 ==========
      loading: false,
      orderList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      filterForm: {
        comlist_v1: '',
        start_date: this.formatDate(start),
        end_date: this.formatDate(today)
      },

      // ========== 详情弹窗 ==========
      detailDialogVisible: false,
      currentDetail: null,

      // ========== 创建入库单 ==========
      createDialogVisible: false,
      submitLoading: false,
      createForm: {
        salesPoint: '默认销售点',
        arrivalDate: this.formatDate(new Date()),
        batchNumber: '',
        remark: '',
        relatedFeesText: '点击添加'
      },
      salesPointList: [],
      selectedGoods: [],
      feePaymentMethod: '',
      feeExpenseCategory: '',
      feeAmount: '',
      paymentMethodOptions: ['现金', '银行卡', '个人微信', '个人支付宝'],
      expenseCategoryOptions: ['手续费', '卸车费', '运费', '三轮费'],
      feeType: '',
      feeAmountVal: 0,

      // ========== 选择货品 ==========
      selectGoodsDialogVisible: false,
      goodsLoading: false,
      goodsList: [],
      goodsPage: 1,
      goodsPageSize: 10,
      goodsTotal: 0,
      groupList: [],
      currentGroupId: null,
      goodsSearchKeyword: '',

      // ========== 货品详情（选择时填写） ==========
      goodsDetailDialogVisible: false,
      goodsDetailForm: {
        id: null,
        name: '',
        specs: [],
        specId: null,
        supplierId: null,
        quantity: 1,
        weight: 0,
        purchasePrice: 0
      },
      supplierList: [],

      // ========== 编辑采购价 ==========
      editPriceDialogVisible: false,
      editPriceGoods: null,
      editPriceValue: 0,
      editPriceLoading: false,

      // ========== 编辑已选货品（创建入库单中） ==========
      editSelectedGoodsDialogVisible: false,
      editSelectedIndex: -1,
      editSelectedForm: {
        name: '',
        mx_comlist_v1: '',
        ghs_id: null,
        quantity: 0,
        weight: 0,
        purchasePrice: 0
      },

      // ========== 批次号计数 ==========
      piciNum: 0,

      // ========== 自动刷新定时器 ==========
      refreshTimer: null
    }
  },

  computed: {
    isConfirmEnabled () {
      return !!(
        this.createForm.arrivalDate &&
        this.createForm.batchNumber &&
        this.selectedGoods.length > 0
      )
    }
  },

  mounted () {
    this.getOrderList()
    this.getSalesPointList()
    this.getSupplierList()
    this.getGroupList()
    this.getPiciNum()
    this.startAutoRefresh()
  },

  beforeDestroy () {
    this.stopAutoRefresh()
  },

  methods: {
    // ===================== 工具方法 =====================
    formatDate (date) {
      if (!date) return ''
      const d = new Date(date)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    formatPrice (val) {
      const num = parseFloat(val)
      return isNaN(num) ? '0.00' : num.toFixed(2)
    },
    parseNum (val) {
      return parseFloat(val) || 0
    },

    // ===================== 列表相关 =====================
    async getOrderList () {
      this.loading = true
      try {
        const userName = localStorage.getItem('user_name')
        const shopId = localStorage.getItem('sh_id')
        const userType = localStorage.getItem('user_type')

        const params = {
          page: this.page,
          pageSize: this.pageSize,
          start_date: this.filterForm.start_date || '',
          end_date: this.filterForm.end_date || '',
          user_name: userName || '',
          shop_id: shopId || '',
          user_type: userType || ''
        }
        if (this.filterForm.comlist_v1 && this.filterForm.comlist_v1.trim()) {
          params.comlist_v1 = this.filterForm.comlist_v1.trim()
        }

        const res = await request.post('/goods/order_in_list.php', params)
        if (res.code === 0) {
          this.orderList = res.data.list || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.msg || '加载失败')
        }
      } catch (e) {
        console.error('获取入库单列表失败', e)
        this.$message.error('网络错误，请重试')
      } finally {
        this.loading = false
      }
    },

    handleSearch () {
      this.page = 1
      this.getOrderList()
    },
    handleReset () {
      const today = new Date()
      const start = new Date()
      start.setDate(start.getDate() - 30)
      this.filterForm.comlist_v1 = ''
      this.filterForm.start_date = this.formatDate(start)
      this.filterForm.end_date = this.formatDate(today)
      this.page = 1
      this.getOrderList()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.page = 1
      this.getOrderList()
    },
    handleCurrentChange (val) {
      this.page = val
      this.getOrderList()
    },

    calculateTotalQuantity (item) {
      if (!item.goods_list || !Array.isArray(item.goods_list)) return 0
      return item.goods_list.reduce((sum, g) => sum + (parseInt(g.comlist_s1) || 0), 0)
    },
    calculateTotalWeightForList (item) {
      if (!item.goods_list || !Array.isArray(item.goods_list)) return '0.00'
      const total = item.goods_list.reduce((sum, g) => sum + (parseFloat(g.comlist_v6) || 0), 0)
      return total.toFixed(2)
    },
    calculateTotalAmountForList (item) {
      if (!item.goods_list || !Array.isArray(item.goods_list)) return '0.00'
      const total = item.goods_list.reduce((sum, g) => {
        const qty = parseFloat(g.comlist_s1) || 0
        const price = parseFloat(g.comlist_f1) || 0
        return sum + qty * price
      }, 0)
      return total.toFixed(2)
    },

    // ===================== 详情弹窗 =====================
    openDetail (row) {
      this.currentDetail = row
      this.detailDialogVisible = true
    },
    closeDetail () {
      this.detailDialogVisible = false
      this.currentDetail = null
    },
    calculateSubtotal (goods) {
      const qty = parseFloat(goods.comlist_s1) || 0
      const price = parseFloat(goods.comlist_f1) || 0
      return (qty * price).toFixed(2)
    },
    calculateTotalQuantityForDetail (goodsList) {
      if (!goodsList || !Array.isArray(goodsList)) return 0
      return goodsList.reduce((sum, g) => sum + (parseFloat(g.comlist_s1) || 0), 0)
    },
    calculateTotalWeight (goodsList) {
      if (!goodsList || !Array.isArray(goodsList)) return '0.00'
      const total = goodsList.reduce((sum, g) => sum + (parseFloat(g.comlist_v6) || 0), 0)
      return total.toFixed(2)
    },
    calculateTotalAmount (goodsList) {
      if (!goodsList || !Array.isArray(goodsList)) return '0.00'
      const total = goodsList.reduce((sum, g) => {
        const qty = parseFloat(g.comlist_s1) || 0
        const price = parseFloat(g.comlist_f1) || 0
        return sum + qty * price
      }, 0)
      return total.toFixed(2)
    },
    calculateFinalTotal (order) {
      const goodsTotal = parseFloat(this.calculateTotalAmount(order.goods_list)) || 0
      const fee = parseFloat(order.feeAmount) || 0
      return (goodsTotal + fee).toFixed(2)
    },

    // ===================== 编辑采购价 =====================
    openEditPrice (goods) {
      this.editPriceGoods = goods
      this.editPriceValue = parseFloat(goods.comlist_f1) || 0
      this.editPriceDialogVisible = true
    },
    async confirmEditPrice () {
      if (!this.editPriceGoods) return
      const inId = this.editPriceGoods.id
      const newPrice = this.editPriceValue
      if (isNaN(newPrice) || newPrice < 0) {
        this.$message.warning('请输入有效价格')
        return
      }
      this.editPriceLoading = true
      try {
        const res = await request.post(
          '/goods/goods_in_edit.php',
          { in_id: inId, comlist_f1: newPrice }
        )
        if (res.code === 0) {
          this.$message.success('修改成功')
          this.editPriceGoods.comlist_f1 = newPrice
          this.editPriceDialogVisible = false
          this.getOrderList()
        } else {
          this.$message.error(res.msg || '修改失败')
        }
      } catch (e) {
        console.error('修改采购价失败', e)
        this.$message.error('网络错误')
      } finally {
        this.editPriceLoading = false
      }
    },

    // ===================== 创建入库单 =====================
    async getSalesPointList () {
      try {
        const shopId = localStorage.getItem('sh_id')
        const userType = localStorage.getItem('user_type')
        const res = await request.post('/goods/salespoint_list.php', {
          sh_id: shopId,
          user_type: userType
        })
        if (res.code === 0) {
          this.salesPointList = res.pointList || []
          if (this.salesPointList.length > 0) {
            this.createForm.salesPoint = this.salesPointList[0].name
          }
        }
      } catch (e) {
        console.error('获取销售点失败', e)
      }
    },

    async getSupplierList () {
      try {
        const shId = localStorage.getItem('sh_id')
        const res = await request.post('/goods/goods_com_list.php', { shId })
        if (res.com_list) {
          this.supplierList = res.com_list.map(item => ({
            id: item.id,
            name: item.comlist_v1
          }))
        }
      } catch (e) {
        console.error('获取供货商列表失败', e)
      }
    },

    async getGroupList () {
      try {
        const shopId = localStorage.getItem('sh_id')
        const res = await request.post(
          '/goods/fenzu_jiben_list.php',
          { bfenlei1: shopId }
        )
        if (res.code === 0 && Array.isArray(res.fenzuList)) {
          this.groupList = res.fenzuList.map(item => ({
            id: item.id,
            name: item.bfenlei4
          }))
          if (this.groupList.length > 0) {
            this.currentGroupId = this.groupList[0].id
          }
        }
      } catch (e) {
        console.error('获取分组列表失败', e)
      }
    },

    async getPiciNum () {
      try {
        const shId = localStorage.getItem('sh_id')
        const res = await request.post('/goods/get_pici_num.php', { shId })
        this.piciNum = res.pici_num || 0
        this.generateBatchNumber()
      } catch (e) {
        console.error('获取批次号失败', e)
      }
    },

    generateBatchNumber () {
      const now = new Date()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      this.createForm.batchNumber = `${month}-${day}-第${this.piciNum || 0}批`
    },

    openCreateDialog () {
      this.createDialogVisible = true
      const now = new Date()
      this.createForm.arrivalDate = this.formatDate(now)
      this.getPiciNum()
      this.selectedGoods = []
      this.feePaymentMethod = ''
      this.feeExpenseCategory = ''
      this.feeAmount = ''
      this.createForm.relatedFeesText = '点击添加'
      this.feeType = ''
      this.feeAmountVal = 0
    },

    resetCreateForm () {
      this.selectedGoods = []
      this.feePaymentMethod = ''
      this.feeExpenseCategory = ''
      this.feeAmount = ''
      this.createForm.relatedFeesText = '点击添加'
    },

    addRelatedFee () {
      if (!this.feePaymentMethod || !this.feeExpenseCategory || !this.feeAmount || parseFloat(this.feeAmount) <= 0) {
        this.$message.warning('请完整填写支付方式、支出类别和金额')
        return
      }
      this.feeType = this.feeExpenseCategory
      this.feeAmountVal = parseFloat(this.feeAmount)
      this.createForm.relatedFeesText = `已添加费用（${this.feePaymentMethod} ${this.feeExpenseCategory}：${this.feeAmount}元）`
      this.$message.success('费用已添加')
    },

    // ===================== 选择货品 =====================
    openSelectGoods () {
      this.selectGoodsDialogVisible = true
      this.goodsPage = 1
      this.fetchGoodsData()
    },

    closeSelectGoods () {
      this.selectGoodsDialogVisible = false
    },

    async fetchGoodsData () {
      this.goodsLoading = true
      try {
        const shId = localStorage.getItem('sh_id')
        const userType = localStorage.getItem('user_type')
        const params = {
          sh_id: shId,
          user_type: userType,
          comlist_v5_1: this.currentGroupId || 0
        }
        if (this.goodsSearchKeyword && this.goodsSearchKeyword.trim()) {
          params.goods_name = this.goodsSearchKeyword.trim()
        }
        const res = await request.post(
          '/goods/fenzu_goods_list.php',
          params
        )
        if (res.code === 0 && Array.isArray(res.fzgoodsList)) {
          this.goodsList = res.fzgoodsList.map(item => {
            const specs = (item.goods_mx || []).map(spec => ({
              id: spec.id,
              comlist_v1: spec.comlist_v1 || '',
              comlist_f2: parseFloat(spec.comlist_f2) || 0,
              comlist_s1: parseFloat(spec.comlist_s1) || 0
            }))
            return {
              goods_id: item.id,
              goods_name: item.comlist_v1 || '',
              specs,
              goods_mx: item.goods_mx || [],
              total_stock: specs.reduce((sum, s) => sum + s.comlist_s1, 0)
            }
          })
          this.goodsTotal = this.goodsList.length
        } else {
          this.goodsList = []
          this.goodsTotal = 0
        }
      } catch (e) {
        console.error('获取货品列表失败', e)
        this.$message.error('获取货品列表失败')
      } finally {
        this.goodsLoading = false
      }
    },

    handleGoodsPageChange (val) {
      this.goodsPage = val
      this.fetchGoodsData()
    },

    getGoodsStock (row) {
      if (row.specs && row.specs.length > 0) {
        return row.specs.reduce((sum, s) => sum + s.comlist_s1, 0)
      }
      return row.total_stock || 0
    },

    // ===================== 货品详情（选择时填写） =====================
    openGoodsDetail (goods) {
      const specs = goods.specs || []
      this.goodsDetailForm = {
        id: goods.goods_id,
        name: goods.goods_name,
        specs: specs,
        specId: specs.length > 0 ? specs[0].id : null,
        supplierId: null,
        quantity: 1,
        weight: 0,
        purchasePrice: specs.length > 0 ? specs[0].comlist_f2 : 0
      }
      // 默认选中第一个供货商
      if (this.supplierList.length > 0) {
        this.goodsDetailForm.supplierId = this.supplierList[0].id
      }
      this.goodsDetailDialogVisible = true
    },

    resetGoodsDetail () {
      this.goodsDetailForm = {
        id: null,
        name: '',
        specs: [],
        specId: null,
        supplierId: null,
        quantity: 1,
        weight: 0,
        purchasePrice: 0
      }
    },

    onSpecChange (specId) {
      const spec = this.goodsDetailForm.specs.find(s => s.id === specId)
      if (spec) {
        this.goodsDetailForm.purchasePrice = spec.comlist_f2 || 0
      }
    },

    confirmGoodsDetail () {
      const form = this.goodsDetailForm
      if (!form.specId) {
        this.$message.warning('请选择规格')
        return
      }
      //   if (!form.supplierId) {
      //     this.$message.warning('请选择供货商')
      //     return
      //   }
      if (form.quantity <= 0) {
        this.$message.warning('数量必须大于0')
        return
      }
      if (form.purchasePrice < 0) {
        this.$message.warning('采购价不能为负数')
        return
      }

      const spec = form.specs.find(s => s.id === form.specId)
      const supplier = this.supplierList.find(s => s.id === form.supplierId)

      // 检查是否已添加相同货品+规格
      const existIdx = this.selectedGoods.findIndex(
        item => item.id === form.id && item.mx_id === form.specId
      )
      if (existIdx >= 0) {
        this.$message.warning('该货品规格已添加，请编辑或删除后重试')
        return
      }

      this.selectedGoods.push({
        id: form.id,
        name: form.name,
        mx_id: form.specId,
        mx_comlist_v1: spec ? spec.comlist_v1 : '',
        quantity: form.quantity,
        weight: form.weight || 0,
        purchasePrice: form.purchasePrice,
        ghs_id: form.supplierId,
        ghs_name: supplier ? supplier.name : ''
      })

      this.$message.success('添加成功')
      this.goodsDetailDialogVisible = false
    },

    // ===================== 编辑已选货品（创建入库单中） =====================
    openEditGoods (index) {
      const item = this.selectedGoods[index]
      if (!item) return
      this.editSelectedIndex = index
      this.editSelectedForm = {
        name: item.name,
        mx_comlist_v1: item.mx_comlist_v1 || '',
        ghs_id: item.ghs_id || null,
        quantity: item.quantity,
        weight: item.weight || 0,
        purchasePrice: item.purchasePrice
      }
      this.editSelectedGoodsDialogVisible = true
    },

    confirmEditSelectedGoods () {
      const idx = this.editSelectedIndex
      if (idx < 0 || idx >= this.selectedGoods.length) return
      const form = this.editSelectedForm
      if (form.quantity <= 0) {
        this.$message.warning('数量必须大于0')
        return
      }
      if (form.purchasePrice < 0) {
        this.$message.warning('采购价不能为负数')
        return
      }
      const supplier = this.supplierList.find(s => s.id === form.ghs_id)
      this.selectedGoods[idx] = {
        ...this.selectedGoods[idx],
        quantity: form.quantity,
        weight: form.weight || 0,
        purchasePrice: form.purchasePrice,
        ghs_id: form.ghs_id,
        ghs_name: supplier ? supplier.name : ''
      }
      this.editSelectedGoodsDialogVisible = false
      this.$message.success('更新成功')
    },

    deleteGoods (index) {
      this.$confirm('确定删除该货品吗？', '提示', { type: 'warning' }).then(() => {
        this.selectedGoods.splice(index, 1)
        this.$message.success('已删除')
      }).catch(() => {})
    },

    // ===================== 提交入库 =====================
    async submitInStock () {
      if (!this.isConfirmEnabled) return
      this.submitLoading = true
      try {
        const shopId = localStorage.getItem('sh_id')
        const userName = localStorage.getItem('user_name')
        const userId = localStorage.getItem('user_id')
        const workId = localStorage.getItem('work_id')

        // 构建goods_list
        const goodsList = this.selectedGoods.map(item => ({
          goods_id: item.id,
          goods_name: item.name,
          mx_id: item.mx_id,
          mx_comlist_v1: item.mx_comlist_v1 || '',
          comlist_s1: item.quantity,
          comlist_v6: item.weight || 0,
          comlist_f1: item.purchasePrice,
          ghs_id: item.ghs_id || '',
          ghs_name: item.ghs_name || ''
        }))

        const submitData = {
          user_name: userName || '',
          sales_point: this.createForm.salesPoint || '销售点',
          arrival_date: this.createForm.arrivalDate,
          batch_number: this.createForm.batchNumber,
          remark: this.createForm.remark || '',
          comlist_v4: this.feeType || '',
          comlist_v5: this.feeAmountVal || 0,
          goods_list: JSON.stringify(goodsList),
          ShopId: shopId || '',
          user_id: userId || '',
          work_id: workId || ''
        }

        const res = await request.post(
          '/goods/goods_in_add.php',
          submitData
        )

        if (res.code === 0) {
          this.$message.success('入库成功')
          this.createDialogVisible = false
          this.selectedGoods = []
          this.getOrderList()
          // 刷新批次号
          this.getPiciNum()
        } else {
          this.$message.error(res.msg || '入库失败')
        }
      } catch (e) {
        console.error('提交入库失败', e)
        this.$message.error('网络错误，请重试')
      } finally {
        this.submitLoading = false
      }
    },

    // ===================== 导入Excel =====================
    handleImportExcel () {
      // 创建隐藏的 file input
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.xlsx,.xls'
      input.onchange = (e) => {
        const file = e.target.files[0]
        if (!file) return
        if (file.size > 5 * 1024 * 1024) {
          this.$message.warning('文件过大，请选择小于5MB的文件')
          return
        }
        this.uploadExcelFile(file)
        input.value = ''
      }
      input.click()
    },

    async uploadExcelFile (file) {
      const shId = localStorage.getItem('sh_id')
      const formData = new FormData()
      formData.append('exc', file)
      formData.append('sh_id', shId)

      try {
        const res = await request.post('/order/excel_export.php', formData)
        if (res.code === 0) {
          this.$message.success('导入成功')
          this.getOrderList()
        } else {
          this.$message.error(res.msg || '导入失败，请检查文件格式')
        }
      } catch (e) {
        console.error('导入失败', e)
        this.$message.error('导入失败，请检查网络或文件格式')
      }
    },

    // ===================== 自动刷新 =====================
    startAutoRefresh () {
      if (this.refreshTimer) return
      this.refreshTimer = setInterval(() => {
        this.getOrderList()
      }, 300000)
    },
    stopAutoRefresh () {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer)
        this.refreshTimer = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order-container {
  padding: 0 20px 20px;
  background-color: #f0f2f6;
  min-height: 85vh;
  box-sizing: border-box;

  .filter-card {
    margin-bottom: 16px;
    .filter-form {
      margin-bottom: 0;
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }

  .table-card {
    height: 71vh;
    overflow-y: auto;
    .pagination {
      margin-top: 16px;
      text-align: right;
    }
  }

  .money {
    color: #ee530c;
    font-weight: 600;
  }

  .detail-desc {
    .el-descriptions-item {
      .el-descriptions-item__label {
        width: 100px;
      }
    }
  }
}
</style>
